import { render, staticRenderFns } from "./editMeasure.vue?vue&type=template&id=10255d78&scoped=true"
import script from "./editMeasure.vue?vue&type=script&lang=js"
export * from "./editMeasure.vue?vue&type=script&lang=js"
import style0 from "./editMeasure.vue?vue&type=style&index=0&id=10255d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10255d78",
  null
  
)

export default component.exports